/**
 * Bersihkan data localStorage terkait session.
 * Token JWT tidak perlu dihapus dari localStorage karena sekarang
 * sudah tidak disimpan di localStorage.
 *
 * Dipakai bersama oleh router/index.js dan semua halaman login
 * (login.vue, login-pegawai.vue, dst) supaya sesi dari satu tipe
 * login (mis. pegawai) tidak nyangkut saat user login sebagai tipe
 * lain (mis. admin/CERMAT) di browser yang sama.
 */
export function clearClientSession() {
  const keys = [
    "session_user_id",
    "session_username",
    "session_name",
    "session_path_photo",
    "session_role",
    "session_role_active_id",
    "session_role_active_name",
    "session_role_active_index",
    "session_menu_access",
    "session",
    "user",
    "configuration",
    "reload_already",
    "dateLogin",
    "roles_data_akses_menu",
    "roles_data_akses_kode_tes",
    "is_validator",
    "is_penyusunSoal",
    "isWrite",
    "isRead",
    "menu_read_names",
    "menu_write_names",
    "kode_tes_active",
    "user_pegawai",
    "filtered_menu",
    "filtered_name_menu",

    // legacy cleanup
    "access_token",
    "access_token_penilai",
  ];

  keys.forEach((key) => localStorage.removeItem(key));
}
